module.exports = __webpack_public_path__ + "images/timothy-parsa.12f86290af66d75d6a0985dab01575f5.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/timothy-parsa.jpeg
// module id = 1032
// module chunks = 0